import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  postApproval,
  postPrint,
  postFile,
  getFile,
  deleteFpre,
  getParam,
  postRejectApproval,
  getMultiplePrint,
  getFareye,
} from "./deliveryApi";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  uploadDocId: null,
  file: null,
  statusParam: [],
};

export const fetchAll = createAsyncThunk(
  "delivery/fetchAll",
  async (payload) => {
    const response = await getAll(payload);
    return response.data;
  }
);

export const fetchFareye = createAsyncThunk(
  "delivery/fetchFareye",
  async (retNumber) => {
    const response = await getFareye(retNumber);
    return response.data;
  }
);

export const updatePrint = createAsyncThunk(
  "delivery/updatePrint",
  async (retNumber) => {
    const response = await postPrint(retNumber);
    return response.data;
  }
);

export const uploadFile = createAsyncThunk(
  "delivery/uploadFile",
  async ({ retNumber, file }) => {
    const response = await postFile(retNumber, file);
    return response.data;
  }
);

export const downloadFile = createAsyncThunk(
  "delivery/downloadFile",
  async (retNumber) => {
    const response = await getFile(retNumber);
    return response.data;
  }
);

export const createApproval = createAsyncThunk(
  "delivery/createApproval",
  async ({ retNumber, payload }) => {
    const response = await postApproval(retNumber, payload);
    return response;
  }
);

export const rejectApproval = createAsyncThunk(
  "delivery/rejectApproval",
  async ({ retNumber, payload }) => {
    const response = await postRejectApproval(retNumber, payload);
    return response;
  }
);

export const removeFpre = createAsyncThunk(
  "delivery/removeFpre",
  async (id) => {
    const response = await deleteFpre(id);
    return response.data;
  }
);

export const fetchStatusParam = createAsyncThunk(
  "delivery/fetchStatusParam",
  async (payload) => {
    const response = await getParam(payload);
    return response.data;
  }
);

export const fetchMultiplePrint = createAsyncThunk(
  "delivery/fetchMultiplePrint",
  async (payload) => {
    console.log(payload, "payload");
    const response = await getMultiplePrint(payload);
    return response;
  }
);

export const deliverySlice = createSlice({
  name: "delivery",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setApproval: (state, action) => {
      state.approval = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(createApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(createApproval.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createApproval.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(rejectApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(rejectApproval.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(rejectApproval.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updatePrint.pending, (state) => {
        state.loading = false;
      })
      .addCase(updatePrint.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updatePrint.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(uploadFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadDocId = action.payload.data;
      })
      .addCase(uploadFile.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(downloadFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(downloadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.file = action.payload;
      })
      .addCase(downloadFile.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchStatusParam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStatusParam.fulfilled, (state, action) => {
        state.loading = false;
        state.statusParam = action.payload.data;
      })
      .addCase(fetchFareye.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFareye.fulfilled, (state, action) => {
        state.loading = false;
      });
  },
});

export const { resetData, setSelected, setApproval } = deliverySlice.actions;

export const selectData = (state) => state.delivery.data;
export const selectLoading = (state) => state.delivery.loading;
export const selectError = (state) => state.delivery.error;
export const selectPageNo = (state) => state.delivery.pageNo;
export const selectPageSize = (state) => state.delivery.pageSize;
export const selectTotalRecord = (state) => state.delivery.totalRecord;
export const selectSelected = (state) => state.delivery.selected;
export const selectApproval = (state) => state.delivery.approval;
export const selectUploadDocId = (state) => state.delivery.uploadDocId;
export const selectStatusParam = (state) => state.delivery.statusParam;

export default deliverySlice.reducer;
